module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Bajo Electrico RO.d7e54851.png";